// @ts-nocheck
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, IconButton, Modal, Tooltip, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { Add, AddCard } from "@mui/icons-material";
import ReimbursementAcc from "../../../../components/Accordions/ReimburesementAcc";
import { Close } from "@mui/icons-material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import LoadingOverlay from "../../../../components/Custom/LoadingOverlay";
import theme from "../../../../theme";
import DeductionAcc from "../../../../components/Accordions/DeductionAcc";
import _ from "lodash";
import { getLocationSuffix } from "../../../../utils/country-state-city/methods";
import SelectConPosForReimb from "../../../event-details/components/additionalComponents/SelectConPosForReimb";

export function DeductionModal({
  open,
  handleClose,
  user,
  eventId,
  data,
  title = "",
  otherData,
  openDraft = false,
  fetchPO = () => {},
  positionList = [],
  openPositionSelector = false,
}) {
  const initialRef = useRef(true);
  const [expanded, setExpanded] = React.useState(false);
  const [selectReimb, setSelectReimb] = useState({
    status: false,
  });
  const [selectedPositon, setSelectedPosition] = useState(null);
  const [reimbursementForm, setReimbursementForm] = React.useState([]);
  const { eaLoading, arLoading } = useSelector(
    (state) => state.adjustmentsReducer,
  );

  function modalClose() {
    initialRef.current = true;
    handleClose();
    setSelectedPosition(null);
  }

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  React.useEffect(() => {
    if (!open) return;
    setReimbursementForm([
      ...(openDraft && initialRef?.current ? [{ newValues: true }] : []),
      ...(data?.reverse() || []),
    ]);

    setTimeout(() => {
      if (
        openDraft &&
        initialRef?.current &&
        (otherData?.positionDetails?._id || selectedPositon?._id)
      ) {
        setExpanded("panel0");
        initialRef.current = false;
      }
    }, 0);
  }, [data, openDraft, open, otherData?.positionDetails, selectedPositon]);

  useEffect(() => {
    if (otherData?.positionDetails?._id && openPositionSelector) {
      setSelectReimb({ status: true });
    }
  }, [otherData?.positionDetails?._id, openPositionSelector]);

  const totalDeduction = useMemo(() => {
    return parseFloat(_.sumBy(data, "deductionAmount")).toFixed(2);
  }, [data]);

  const style = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: 24,
    padding: 4,
    minWidth: "47%",
    backgroundColor: "#000",
    zIndiex: 9,
    borderRadius: "16px",
    border: "2px solid #D175B6",
    minHeight: "68%",
    width: "520px",
    maxHeight: "90vh",
    overflowY: "auto",
    "@media (max-width: 900px)": {
      width: "80%",
      minWidth: "0",
      height: "80%",
      overflowY: "auto",
    },
    "@media (max-width: 600px)": {
      width: "96%",
      minWidth: "0",
      height: "96%",
      overflowY: "auto",
    },
  };

  return (
    <Modal
      open={open}
      onClose={modalClose}
      aria-labelledby="reimbursement modal"
      aria-describedby="reimbursement modal"
    >
      <Box sx={style}>
        {eaLoading || arLoading ? (
          <LoadingOverlay open={true} />
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: "0.75rem",
              position: "relative",
            }}
          >
            <Typography
              sx={{
                color: "#FFF",
                fontSize: "2rem",
                fontWeight: "500",
                "@media(max-width: 600px)": {
                  fontSize: "1.4rem",
                  fontWeight: "400",
                },
              }}
            >
              {title
                ? title
                : user === "admin"
                  ? "Reimbursement Details"
                  : "Claim Reimbursement"}
            </Typography>

            {user == "admin" && (
              <Tooltip title="Create New Form" arrow placement="left">
                <IconButton
                  sx={{
                    position: "absolute",
                    right: "0rem",
                    top: "0rem",
                    backgroundColor: "#D175B6",
                    borderRadius: "0.5rem",
                    padding: "1rem",
                    "&:hover": {
                      backgroundColor: "#D175B6",
                      opacity: 0.8,
                    },
                    "@media(max-width: 600px)": {
                      padding: "0.4rem",
                    },
                  }}
                  onClick={() => {
                    setReimbursementForm((prev) => {
                      return [
                        {
                          newValues: true,
                        },
                        ...prev,
                      ];
                    });
                    handleChange("panel0");
                  }}
                >
                  <Add
                    sx={{
                      color: "white",
                      fontSize: "20px",
                      "@media(max-width: 600px)": {
                        fontSize: "13px",
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      "@media(max-width: 600px)": {
                        display: "none",
                      },
                    }}
                  >
                    Add New
                  </Typography>
                </IconButton>
              </Tooltip>
            )}

            {(otherData?.positionDetails ||
              otherData?.contractorDetails ||
              selectedPositon) && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent:
                    (otherData?.positionDetails?._id || selectedPositon?._id) &&
                    otherData?.contractorDetails?._id
                      ? "space-between"
                      : "center",
                  alignItems: "center",
                  width: "100%",
                  paddingX: "1.5rem",
                }}
              >
                {(otherData?.positionDetails?._id || selectedPositon?._id) && (
                  <Typography sx={{ fontSize: "1.25rem" }}>
                    <Typography variant="span" color={theme.palette.green.main}>
                      Position Name:{" "}
                    </Typography>
                    {otherData?.positionDetails?.name ||
                      selectedPositon?.positionName}
                  </Typography>
                )}
                {otherData?.contractorDetails?._id && (
                  <Typography sx={{ fontSize: "1.25rem" }}>
                    <Typography variant="span" color={theme.palette.green.main}>
                      Contractor Name:{" "}
                    </Typography>

                    {(() => {
                      const name = otherData?.contractorDetails?.name;
                      const locationSuffix = getLocationSuffix({
                        state: otherData?.contractorDetails?.state,
                        city: otherData?.contractorDetails?.city,
                      });
                      return name + locationSuffix;
                    })()}
                  </Typography>
                )}
              </Box>
            )}

            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                gap: "0.5rem",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <Typography sx={{ fontSize: "1rem" }}>
                <Typography variant="span" color={theme.palette.green.main}>
                  Total Deduction Amount:{" "}
                </Typography>
                ${totalDeduction}
              </Typography>
            </Box>

            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                gap: "1rem",
                padding: "1.5rem",
                "@media(max-width: 600px)": {
                  padding: "0.1rem",
                },
              }}
            >
              {reimbursementForm?.map((data, index) => {
                return (
                  <div
                    style={{ position: "relative", width: "100%" }}
                    key={index}
                  >
                    <DeductionAcc
                      user={user}
                      expanded={expanded}
                      handleAccChange={handleChange}
                      data={{
                        ...data,
                        ...otherData,
                        ...(selectedPositon
                          ? {
                              positionDetails: {
                                _id: selectedPositon?._id,
                                name: selectedPositon?.positionName,
                                startDate: selectedPositon?.startDate,
                              },
                            }
                          : {}),
                        reImbursementStatus:
                          data?.reImbursementStatus || "draft",
                      }}
                      setData={setReimbursementForm}
                      eventId={eventId}
                      isEditable={
                        !data?.reImbursementStatus ||
                        data?.reImburesmentStatus?.toLowerCase() === "draft"
                      }
                      index={index}
                      status={data?.reImbursementStatus || "draft"}
                      fetchPO={fetchPO}
                    />
                    {(data?.reImbursementStatus === "draft" ||
                      !data?.reImbursementStatus) && (
                      <IconButton
                        sx={{
                          position: "absolute",
                          top: "-10px",
                          right: "-10px",
                          backgroundColor: "#D175B6",
                          borderRadius: "50%",
                          padding: "1rem",
                          "&:hover": {
                            backgroundColor: "#D175B6",
                            opacity: 0.8,
                          },
                          height: "2rem",
                          width: "2rem",
                        }}
                        onClick={() => {
                          setReimbursementForm((prev) => {
                            return prev.filter((_, i) => i !== index);
                          });
                        }}
                      >
                        <Close sx={{ fontSize: "1rem", color: "white" }} />
                      </IconButton>
                    )}
                  </div>
                );
              })}
            </Box>

            {selectReimb?.status && (
              <SelectConPosForReimb
                open={selectReimb?.status}
                onClose={() => {
                  setSelectReimb((prev) => ({ ...prev, status: false }));
                }}
                positionList={positionList}
                selectedContractor={otherData?.contractorDetails}
                onSelect={(data) => {
                  setSelectedPosition(data?.pos);
                  setSelectReimb((prev) => ({ ...prev, status: false }));
                }}
                buttonText={"Continue"}
              />
            )}
          </Box>
        )}
      </Box>
    </Modal>
  );
}

DeductionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  user: PropTypes.string,
  eventId: PropTypes.string,
  data: PropTypes.array,
  otherData: PropTypes.object,
  title: PropTypes.string,
  fetchPO: PropTypes.func,
  openDraft: PropTypes.bool,
};